<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <popup-header v-on:clickClose="closeModal()" />
      <vacation-select-date-header />
      <select-date-title-vacation
        :activeTab="activeTab"
      ></select-date-title-vacation>
      <select-date-content-vacation
        @selectDate="selectDate"
      ></select-date-content-vacation>
    </div>
  </v-dialog>
</template>
<script>
import PopupHeader from '@/components/common/PopupHeader.vue';
import VacationSelectDateHeader from '@/components/application/form/VacationSelectDateHeader.vue';
import SelectDateContentVacation from '@/components/application/form/SelectDateContentVacation.vue';
import SelectDateTitleVacation from '@/components/application/form/SelectDateTitleVacation.vue';

//import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
//import applCode from '@/const/applCodeConstants';

export default {
  mixins: [applCdMixin, dialogMixin],
  components: {
    VacationSelectDateHeader,
    SelectDateContentVacation,
    SelectDateTitleVacation,
    PopupHeader,
  },
  data: () => ({
    modalName: 'date_vacation_app2',
    activeTab: 'E',
    type: '',
  }),
  computed: {
    ...mapGetters('ELA', ['GET_S_YMD', 'GET_E_YMD']),
    ...mapGetters([
      'GET_APPL_CD',
      'GET_RETURNYMD',
      'GET_APPL_TYPE',
      'GET_HOL_REPLACE_PERIOD_DATA',
      'GET_WORK_TYPE_CD',
    ]),
  },
  methods: {
    async selectDate(date) {
      this.$parent.sYmd = dayjs(date).format('YYYY-MM-DD');
      this.closeModal();
      this.OFF_APP_SPINNER();
    },
  },
  mounted() {},
  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
};
</script>
<style></style>
